import { isAdminLikeRole, getAppRoleLabel } from './roles';

/** ロールに応じた日本語ラベルを返す */
export function getRoleLabel(role?: string): string {
  return getAppRoleLabel(role);
}

/** ロールに応じた通知・お知らせ・メッセージの遷移先パスを返す */
export function getRoleNavPaths(role?: string): {
  announcementsPath: string;
  messagesPath?: string;
  notificationsPath?: string;
} {
  const isAdmin = isAdminLikeRole(role);
  return {
    announcementsPath: isAdmin ? '/admin/announcements' : '/user/announcements',
    messagesPath: isAdmin ? '/admin/messages' : undefined,
    notificationsPath: isAdmin ? '/admin/notifications' : undefined,
  };
}

/**
 * ロールに応じたホーム（ダッシュボード）パスを返す。
 * 管理系ロール（職員・事業所管理者・福祉事業管轄・総合管理者）は管理ダッシュボード、
 * それ以外は利用者ダッシュボード。
 * ※ ITフラグ（is_it_admin / is_it_developer）ではなくロールで判定する。
 *   フラグ保有の有無で戻り先を決めると、フラグを持たない管理職が利用者側へ飛ばされる。
 */
export function getHomePathByRole(role?: string | null): string {
  return isAdminLikeRole(role) ? '/admin/dashboard' : '/user/dashboard';
}